import { Capacitor } from '@capacitor/core';

export const MOBILE_SCREEN_UTILS = {
  isMobileScreen() {
    return Capacitor.isNativePlatform() || window.innerWidth <= 640;
  },

  isTabletScreen() {
    return Capacitor.isNativePlatform() || window.innerWidth <= 999;
  },
};
